import { Component, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { CommonService } from '../common-service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MarkdownService } from '../markdown-service';
import { SanitizationService } from '../sanitization.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MdEditorOption } from 'ngx-markdown-editor/public_api';
import { WebSocketService } from '../websocket.service';
import { clippingParents } from '@popperjs/core';
import * as moment from 'moment';
interface Document {
  fileId: number;
  file_name: string;
  status: string;   // Ensure this property is included
  created_at: string;
}
@Component({
  selector: 'app-kh-doc',
  templateUrl: './kh-doc.component.html',
  styleUrl: './kh-doc.component.scss'
})
export class KhDocComponent implements OnInit {
  documentName:any
  // files:any
  showmodal=false
  selectedfilecontent:any=""
  modalloader=true
  rows: number = 10;
  totalrecords = 0
  first: number = 0;
  pagenumber: number = 1;
  loader=true
  isEditMode: boolean=false;
  public editableDocument: any = { content: '' };
  syncingLoader: boolean=false;
  role!: string | null;
  isPreviewMode=false;
  public editorOptions: MdEditorOption = {
    showPreviewPanel: true,
    resizable: true,
    fontAwesomeVersion: '6',
    markedjsOpt: {
      sanitize: true
    }
  };
  public mode: string = 'editor';
  files: Document[] = [];
  collection_id: any;
  selectedcollection: any;
  availableCollections: any;
  showuploadmodal: boolean=false;
  collection_to_upload_doc: any;
  filearray: File[] = [];
  uploadloader: boolean= false;
  searchText: any;
  searchContentText: any;
  user_id: any;
  filteredDocuments: any[] = [];
  showSuggestions = false;

   constructor(private api:CommonService,private route:ActivatedRoute,
    private markdownService: MarkdownService,private sanitizer: DomSanitizer,private messageService: MessageService,
    public sanitizeService:SanitizationService,public webSocketService:WebSocketService,private router:Router,private confirmationService: ConfirmationService
  ){
    this.role = localStorage.getItem('role')
    this.route.params.subscribe(params => {
      this.documentName = params['documentname'],
      this.user_id=localStorage.getItem('user_id')
    })
  }

  ngOnInit(): void {
   this.collection_id=localStorage.getItem('collectionId');
    this.fetchDocuments()
    this.setupWebSocket();
  }
  
  private fetchDocuments(): void {
    const payload = {
      collection_name: this.documentName,
      page: this.pagenumber,
      limit: 10    
    };
    this.api.postMethod('get-collection-documents', payload).subscribe((data: any) => {
      const documents= data[this.documentName] ||[];      
      this.files = documents.sort((a: any, b: any) => {
      const dateA = new Date(a.updated_at.replace(/(\d{2}) (\w{3}) (\d{4})/, '$2 $1, $3'));
      const dateB = new Date(b.updated_at.replace(/(\d{2}) (\w{3}) (\d{4})/, '$2 $1, $3'));
      return dateB.getTime() - dateA.getTime();
  });

      this.totalrecords = data.totalActiveDocuments; 
      this.loader = false;
    });
  }
  onSearchChange(): void {
  this.pagenumber = 1;
  this.first=0;
  if (this.searchText && this.searchText.trim() !== '') {
    this.searchDocuments(); // call search API
  } else {
    this.fetchDocuments();  // call default listing API
  }
}

  searchDocuments(): void {
  if (!this.searchText?.trim()) {
    this.pagenumber=1;
    this.fetchDocuments(); // fallback to original list
    return;
  }

  const payload = {
    collection_name: this.documentName,
    search_query: this.searchText.trim(),
    limit: 10,
    page: this.pagenumber
  };

  this.api.postMethod('search-collection-documents', payload).subscribe((data: any) => {
    this.files = data[this.documentName] || [];
    this.totalrecords = data.total || 0;
    // this.highlightedText = this.searchText.trim();
    this.loader = false;
  });
}


           onContentAutoComplete(event: any): void {
              const query = event.query.trim();
              if (query) {
                const payload = {
                  search_query: query,
                  filters: {
                    status: true,
                    collection: { collection_id: Number(this.collection_id) },
                    users: { user_id: this.user_id }
                  },
                  page: 1,
                  page_size: 5 // Limit for suggestions
                };

                this.api.postMethod('api/v1/elasticsearch/search/documents/v2', payload).subscribe({
                  next: (data: any) => {
                    const documents = data.results || [];
                    this.filteredDocuments = (data.results || []).map((doc: any) => ({
                      id: doc.id,
                      file_name: doc.file_name,
                      file_url: doc.url,
                      slug:this.generateSlug(doc.file_name),
                      created_at: this.formatDate(doc.created_at),
                      updated_at: this.formatDate(doc.updated_at),
                      status: doc.document_status || doc.status,
                      metadata: doc.metadata || {},
                      isBookmarked: doc.isBookmarked || false
                    }));
                  },
                  error: (err) => {
                    console.error('Error fetching autocomplete suggestions', err);
                    this.filteredDocuments = [];
                  }
                });
              } else {
                this.filteredDocuments = [];
              }
            }
  generateSlug(fileName: string): string {
  if (!fileName?.trim()) return 'document';

  const name = fileName.split('.').slice(0, -1).join('.') || fileName;
  const chars = name.trim().toLowerCase().split('');
  let slug = '', lastWasHyphen = false;

  for (const ch of chars) {
    const isAlphaNum = (ch >= 'a' && ch <= 'z') || (ch >= '0' && ch <= '9');
    if (isAlphaNum) {
      slug += ch;
      lastWasHyphen = false;
    } else if (!lastWasHyphen && slug.length > 0) {
      slug += '-';
      lastWasHyphen = true;
    }
  }
  if (slug.endsWith('-')) {
    slug = slug.slice(0, -1);
  }

  return slug || 'document';
}


onDocumentSelect(event: any): void {
  const document = event;
  const documentId = document.document_id || document.id;
  if (documentId) {
    window.open(`/document-view/${documentId}`, '_blank');
    // Or use Angular router:
    // this.router.navigate(['/document-view', documentId]);
  }
}

performDocumentSearch(): void {
  this.fetchDocuments(); // or call your existing search logic for full results
}

private formatDate(dateString: string): string {
  return moment(dateString).format('YYYY-MM-DD HH:mm');
}

  viewdoc(file:any,editMode:boolean){
    this.showmodal = true;
    this.isEditMode = editMode;
    this.selectedfilecontent = '';
    this.modalloader=true
    this.isPreviewMode=false
    let payload = {
      "collection_name": this.documentName,
      "document_name": file.file_name
    };
    this.api.postMethod('get-collection-document/v2', payload).subscribe((data: any) => {
      this.modalloader = false;
      this.selectedfilecontent = data;
      if (editMode) {
        this.editableDocument = { ...data, content: data.content };
      }
    });
  }
 
  updateDocument() {
    let payload = {
      "collection_id": this.editableDocument.collection_id,
      "document_id": this.editableDocument.id,
      "document_content": this.editableDocument.content
    };
    
    this.api.putMethod('modify-collection-document', payload).subscribe({
      next: (response: any) => {
        this.syncDocument();
        this.messageService.add({ severity: 'success', detail: response.message });
      },
      error: (error: any) => {
        console.error('Error updating document', error);
        this.showmodal = false;
        this.messageService.add({ severity: 'error', detail: error.error.detail });
        this.modalloader = false;
      }
    });
  }

  syncDocument() {   
    this.showmodal=false
    this.syncingLoader = true;
    let payload = {};
    this.api.singleFileSyncMethod(this.documentName,this.selectedfilecontent.file_name, payload).subscribe({
      next: (response: any) => {
        this.messageService.add({ severity: 'success', detail: response.message });
      },
      error: (err) => {
        console.error('Error while syncing', err);
        this.messageService.add({ severity: 'error', detail: err.error.detail });
        this.showmodal=false
      },
      complete: () => {
        this.syncingLoader = false;
       
      }
    });
  }
  setupWebSocket() {
    this.webSocketService.onDocumentStatus().subscribe({
      next: (data) => {
        this.updateDocumentStatus(data);
      },
      error: (err) => {
        console.error('WebSocket error:', err);
      }
    });
  }

  updateDocumentStatus(update: Document) {
    const index = this.files.findIndex((file:any) => file.id === update.fileId);
    if (index !== -1) {
      this.files[index].status = update.status;
    } else {
      this.totalrecords++;
    }
  }

  onPageChange(event: any): void {
  this.pagenumber = event.page + 1;
  this.first = event.first;
this.ngOnInit()
  if  (this.searchText && this.searchText.trim() !== '')  {
    this.onSearchChange();
  } else {
    this.fetchDocuments();
  }
}

  
   sanitizeMessage(message: string): SafeHtml {
    return this.sanitizeService.sanitizeMessage(message);
   }
   

  onDialogHideaddcollection(){}
  togglePreview(){
    this.isPreviewMode=!this.isPreviewMode;
  }
  deletedoc(data:any){
    if(this.collection_id){
  let body={
    "document_id": Number(data.id),
    "collection_id": Number(this.collection_id)
  }

this.api.deleteMethod("delete-collection-document",body).subscribe({
  next: (data) => {
    
    this.messageService.add({ severity: 'success', detail: data.message });
    this.fetchDocuments();
  },
  error: (err) => {
    this.messageService.add({ severity: 'error', detail: err.message });
    console.error('DeleteError', err);
  }
});}
}
openDOcument(file:any){
  this.router.navigate(['collection', this.documentName, 'document', file.slug]);
  const dataToPass = { documentId: file.id, collectionId: this.collection_id };
  this.api.setData(dataToPass);}
uploadDoc(event: Event,collection_name:any){
  event.stopPropagation();
  this.showuploadmodal = true
  this.collection_to_upload_doc = collection_name
}
handleFileSelection(selectedFiles:any){
  this.filearray = [...this.filearray, ...selectedFiles];
}
handleFileDelete(file:any){
  const filesArray = Array.from(this.filearray);

// Find the index of the file in the array
  const index = filesArray.findIndex(f => f === file);
  if (index !== -1) {
    filesArray.splice(index, 1);
    this.filearray = filesArray
  }
}
handleFileUpload(){
  const token = localStorage.getItem('token');
  if (!token || !this.filearray.length || !this.collection_to_upload_doc) {
    this.messageService.add({ severity: 'warn', summary: 'Invalid Data', detail: 'Please make sure to select files and provide a valid collection name.' });
    return;
  }

  this.uploadloader = true;

  this.api.uploadFiles(this.collection_to_upload_doc, this.filearray, token).subscribe({
    next: (response: any) => {
      this.showuploadmodal = false;
      this.uploadloader = false;

      response.forEach((file: any) => {
        const fileName = file.name;
        
        if (file.isDuplicateFile) {
          this.messageService.add({ 
            severity: 'warn', 
            summary: 'Duplicate File', 
            detail: `${fileName} is a duplicate file and was not uploaded.` 
          });
        } else if (file.isFileUploadedOnS3) {
          this.fetchDocuments();
          this.messageService.add({ 
            severity: 'success', 
            summary: 'File Uploaded', 
            detail: `${fileName} uploaded successfully.` 
          });
        } else {
          this.messageService.add({ 
            severity: 'error', 
            summary: 'Upload Failed', 
            detail: `${fileName} could not be uploaded to S3.` 
          });
        }
      });
    },
    error: (error:any) => {
      console.error('upload-collection-files', error);
      this.messageService.add({ severity: 'error', detail: error.error.detail });
      this.uploadloader = false;
    }
  });
}
navigateToKh(){
  this.router.navigate(['/knowledgehub']);
}
confirmDelete(file:any) {
  this.confirmationService.confirm({
    message: `Are you sure you want to delete <b>${file.file_name}</b>?`,
    header: 'Delete Confirmation',
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      this.deletedoc(file);
    },
    reject: () => {
      this.messageService.add({severity:'info', summary:'Cancelled', detail:'Document deletion was cancelled'});
    }
  });
}
}